import { render, staticRenderFns } from "./ListaDeArtigosPesquisado.vue?vue&type=template&id=6d2b2766&"
import script from "./ListaDeArtigosPesquisado.vue?vue&type=script&lang=js&"
export * from "./ListaDeArtigosPesquisado.vue?vue&type=script&lang=js&"
import style0 from "./ListaDeArtigosPesquisado.vue?vue&type=style&index=0&id=6d2b2766&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports